import {Component, HostListener, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {routes} from 'src/app/shared/routes/routes';
import {SidebarService} from 'src/app/shared/sidebar/sidebar.service';
import {SessionStorageService} from "../../core/web/session.storage.service";
import {AuthService} from "../../core/web/auth.service";
import {PatientService} from "../../core/web/patient.service";
import {User} from "../../core/models/user.model";
import {DoctorService} from "../../core/web/doctor.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    public searchField  = false;
    public routes = routes;
    public user: any;
    base: string = 'patients';
    protected currentLanguage = 'fr';





    constructor(
    private sidebar: SidebarService,
    private router: Router,
    private session:  SessionStorageService,
    private authService: AuthService,
    private doctorService: DoctorService,
    private patientService: PatientService,
    private translateService : TranslateService

    ) {}

  public toggleSidebar(): void {
    this.sidebar.openSidebar();
  }
  public hideSidebar(): void {
    this.sidebar.closeSidebar();
  }
  toggleSearch(){
    this.searchField = !this.searchField
  }
  public navigation() {
    this.router.navigate([routes.search1]);
  }

 @HostListener('window:scroll', [])
  onWindowScroll() {
    const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    const headerOne = document.querySelector('.header-one');
    if (headerOne && scroll > 35) {
      headerOne.classList.add('header-space');
    } else if (headerOne) {
      headerOne.classList.remove('header-space');
    }

    const headerTen = document.querySelector('.header-ten');
    if (headerTen && scroll > 35) {
      headerTen.classList.add('header-space');
    } else if (headerTen) {
      headerTen.classList.remove('header-space');
    }
  }
  ngOnInit(): void {
      this.onLoadAccount();
      console.log()
  }


  onLoadAccount() {
    let loggedUser = this.getLoggedUser();
    if(loggedUser) {

        if(loggedUser.profile == 'PATIENT') {
            this.patientService.getAccount().subscribe(response => {
                this.user = response;
                this.onConvertImage(response.image);
            });
        } else if(loggedUser.profile == 'DOCTOR') {
            this.doctorService.getAccount().subscribe(response => {
                this.user = response;
                this.onConvertImage(response.image);
            });
        }

    }
  }
  onConvertImage(image: any){
      if (image) {
          this.user.image = `data:image/jpeg;base64,${image}`;
      }
  }

  getLoggedUser() : User {
    return this.session.getUser();
  }
  logout(): void {
    this.authService.logout(true);
  }
    protected useLanguage(language: string): void {
        console.log("Selected Language:", language);
        this.translateService.use(language);
        this.currentLanguage = language;
        sessionStorage.setItem('selectedLanguage', language);
    }


}
